import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const stitchData = defineConnector({
  identifier: "stitchData",
  name: "Stitch Data",
  tagLine: "ETL and data pipeline service",
  logo,
  protocol: "http",
  tags: ["data", "engineering"],
  defaultUrlPattern: () => "https://api\\.stitchdata\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Generate a Stitch API access token",
      items: [
        {
          kind: "markdown",
          content:
            "In Stitch, create an API access token for the Stitch Connect API. Stitch documents bearer-token authentication for its public API.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.stitchdata.com/v4/sources",
  },
});
